import { useState } from "react";
import { Link } from "react-router-dom";
import API from "@/lib/api";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import AuthLayout from "@/components/AuthLayout";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Access / Password Recovery"
      title="Reset your password"
      subtitle="Enter the email tied to your account and we'll send you a secure reset link."
    >
      <div data-testid="forgot-password-page" />
      {sent ? (
        <div>
          <div
            className="bg-emerald-50 border border-emerald-200 rounded-md px-4 py-3 text-sm text-emerald-700 mb-6"
            data-testid="reset-sent-msg"
          >
            If an account with that email exists, a password reset link has been sent. Check your inbox.
          </div>
          <Link
            to="/login"
            className="text-[#002FA7] text-sm font-medium hover:underline underline-offset-4"
            data-testid="back-to-login-link"
          >
            Back to Sign In
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          {error && (
            <div
              className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2"
              data-testid="forgot-error"
            >
              {error}
            </div>
          )}
          <div className="space-y-1.5">
            <Label
              htmlFor="email"
              className="text-xs uppercase tracking-[0.2em] text-slate-500 font-bold"
            >
              Email Address
            </Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="h-11"
              placeholder="you@company.com"
              data-testid="forgot-email-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-11 bg-[#002FA7] hover:bg-[#00227A] text-white font-medium tracking-tight"
            data-testid="forgot-submit-btn"
          >
            {loading ? "Sending…" : "Send Reset Link"}
          </Button>
          <p className="text-sm text-slate-500 text-center">
            <Link
              to="/login"
              className="text-[#002FA7] font-medium hover:underline underline-offset-4"
            >
              Back to Sign In
            </Link>
          </p>
        </form>
      )}
    </AuthLayout>
  );
}
